import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { RoleThatFits } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-profile.model';

export const loadRolesThatFit = createAction('[Roles That Fit] Load', props<{ id: number }>());

export const loadRolesThatFitSuccess = createAction(
  '[Roles That Fit] Load Success',
  props<{ roles: RoleThatFits[] }>(),
);

export const loadRolesThatFitError = createAction(
  '[Roles That Fit] Load Error',
  props<{ error: HttpErrorResponse }>(),
);
